// Standalone shared constants. RESET_PASSWORD_PATH lives here (rather than only
// as an entry in URLBuilder's URL map) because the dashboard's pre-React inline
// reset-password sanitizer needs this path at build time and cannot load the
// full @termly-web/common barrel (it pulls in SCSS-importing components).
export const RESET_PASSWORD_PATH = '/user/reset-password'
